export type IResetFileUpload = (
  button: IjQueryElmOrHtmlElm,
  json: {
    inputName: string;
    fieldIdent: string;
    fieldSuffix: string;
    waitMsg: string;
    removeSuccessMsg: string;
    removeErrorMsg: string;
    completeSuccessMsg: string;
    unableToDeleteMsg: string;
  }
) => void;

export function _resetFileUpload(
  button: IjQueryElmOrHtmlElm,
  json: {
    inputName: string;
    fieldIdent: string;
    fieldSuffix: string;
    waitMsg: string;
    removeSuccessMsg: string;
    removeErrorMsg: string;
    completeSuccessMsg: string;
    unableToDeleteMsg: string;
  }
): void {
  const { inputName, fieldIdent, fieldSuffix, waitMsg, removeSuccessMsg, unableToDeleteMsg } = json;
  const $button = $(button);
  const $form = $button.closest('form') as IjQueryElm;
  const action = $form.attr('action') as string;
  const seperator = window.DexeroCoreApp.getUrlSeperator(action);
  const newActionUrl = action + seperator;
  const $uuidInput = $form.find('input[name="uuid"]');
  const uuid = $uuidInput.val();
  const $formGroup = $button.closest('.form-group');
  const $fileNameSpan = $formGroup.find('.file-name');
  const $fileUploadedHolder = $formGroup.find('.file-uploaded-holder');
  const $newFileInput = $formGroup.find(`input[name="${inputName}"]`);
  const $oldFileInput = $formGroup.find(`input[name="${inputName}_old"]`);
  // const resetFileInput = $formGroup.find('input[name="' + inputName + '_reset"]');
  const options = window.DexeroCoreApp.getUserOptions();
  const { langObj = {} } = options;

  // Block Form
  window.DexeroCoreApp.blockUI(waitMsg, $form);
  // Animate Button
  window.DexeroCoreApp.animateButton(button);

  // Form Object
  const formData = new FormData();
  formData.append('partialSave', 'true');
  formData.append('waitForIndexation', 'true');
  formData.append('waitForEvent', 'true');
  formData.append('uuid', uuid as string);
  formData.append(`${fieldIdent}_reset`, 'true');
  formData.append('fieldSuffix', fieldSuffix);
  formData.append(fieldIdent, '');
  // Post new form object which will remove the file from the dataEntry
  $.ajax({
    cache: false,
    contentType: false,
    data: formData,
    processData: false,
    timeout: 90000,
    type: 'POST',
    url: `${newActionUrl}ajax=true`,
    error(jqXHR, textStatus) {
      if (textStatus === 'timeout') {
        const errorTitle = langObj.errorText;
        const errorMessage = langObj.unableToLoadPageText;
        window.DexeroCoreApp.userToastMsg('error', errorTitle, errorMessage);
        window.DexeroCoreApp.animateButton(button);
      }
    },
  })
    .done((data) => {
      if (data.success === 'false') {
        window.DexeroCoreApp.userToastMsg('error', unableToDeleteMsg);
      } else {
        window.DexeroCoreApp.userToastMsg('success', removeSuccessMsg);
        // Remove box from view
        $fileUploadedHolder.addClass('file-deleted hide');
        // Make input field required again if it needs to be
        $newFileInput.removeClass('ignore-for-validation').val('');
        // Reset filename
        $fileNameSpan.removeData('file-name').attr('data-file-name', 'false');
        // Reset old file input value
        $oldFileInput.val('');
      }
    })
    .always(() => {
      // Unblock form
      window.DexeroCoreApp.animateButton(button);
      window.DexeroCoreApp.blockUI(undefined, $form, true);
    });
}
